export enum ShippingMethodCategory {
  DEFAULT = 'default',
  FRESH = 'fresh',
  ULTRA_FRESH = 'ultra_fresh',
}

export type ShippingMethodConfigurationThreshold = {
  threshold: number;
  underThresholdAmount: number;
};

export type ShippingMethodConfiguration = {
  category?: string;
  aboveAllThresholdsAmount: number;
  underThresholdAmount?: number;
  cartTotalThreshold?: number;
  thresholds?: ShippingMethodConfigurationThreshold[];
};

export enum ShippingMethodTypes {
  HOME = 'home',
  CLICK_AND_COLLECT = 'click_and_collect',
  PICKUP = 'pickup',
  COURIER = 'courier',
  NON_ADDRESSED = 'non_addressed',
}

export type ShippingMethod = {
  category: ShippingMethodCategory;
  type: ShippingMethodTypes;
  configuration: ShippingMethodConfiguration;
  code: string;
  tmsCode: string;
};

export type ListEligibleShippingMethodsQueryResult = {
  listEligibleShippingMethods: ShippingMethod[];
};
